export interface Drama {
  id: string;
  title: string;
  category: string;
  categorySlug: string;
  image: string;
  description: string;
  episodes: number;
  year: number;
  rating: number;
  director: string;
  cast: string[];
  status: string;
  updateInfo: string;
  featured: boolean;
  content: string;
}

export const categories = [
  { name: '全部', slug: 'all' },
  { name: '古装剧', slug: 'guzhuang' },
  { name: '现代剧', slug: 'xiandai' },
  { name: '悬疑剧', slug: 'xuanyi' },
  { name: '爱情剧', slug: 'aiqing' },
  { name: '喜剧', slug: 'xiju' },
  { name: '科幻剧', slug: 'kehuan' },
  { name: '历史剧', slug: 'lishi' },
];

export const dramas: Drama[] = [
  {
    id: 'drama-1',
    title: '长安十二时辰',
    category: '古装剧',
    categorySlug: 'guzhuang',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20detective%20drama%20poster%2C%20Tang%20Dynasty%20setting%2C%20mysterious%20atmosphere%2C%20lantern-lit%20ancient%20city%20at%20night%2C%20dramatic%20lighting%2C%20cinematic%20poster%20style%2C%20clean%20background%2C%20professional%20design%2C%20warm%20golden%20and%20dark%20tones&width=600&height=800&seq=drama-1&orientation=portrait',
    description: '唐朝天宝三载，上元节前夕，长安城陷入了一场惊天阴谋。死囚张小敬临危受命，与靖安司司丞李必携手在十二时辰内破解危机，拯救长安城。',
    episodes: 48,
    year: 2019,
    rating: 8.2,
    director: '曹盾',
    cast: ['雷佳音', '易烊千玺', '周一围', '热依扎'],
    status: '已完结',
    updateInfo: '全48集',
    featured: true,
    content: '《长安十二时辰》改编自马伯庸同名小说，讲述了唐朝天宝三载上元节前夕，长安城混入可疑狼卫，死囚张小敬临危受命，与少年名士李必携手在十二时辰内拯救长安的故事。该剧以精良的制作、紧凑的剧情和演员精湛的演技赢得了广泛好评，被誉为"国产古装剧新标杆"。剧情环环相扣，悬疑感十足，每一集都让人欲罢不能。剧中不仅展现了盛唐时期的繁华景象，还通过人物命运折射出深刻的人性思考。',
  },
  {
    id: 'drama-2',
    title: '狂飙',
    category: '现代剧',
    categorySlug: 'xiandai',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20poster%2C%20two%20men%20in%20police%20uniform%20and%20suit%2C%20intense%20stare%2C%20modern%20Chinese%20city%20backdrop%2C%20cinematic%20poster%20with%20dramatic%20lighting%2C%20dark%20blue%20and%20red%20color%20scheme%2C%20professional%20design%2C%20clean%20background&width=600&height=800&seq=drama-2&orientation=portrait',
    description: '以一线刑警安欣为代表的正义力量，与以高启强为首的黑恶势力展开长达二十年的生死较量，展现了扫黑除恶斗争的艰险与复杂。',
    episodes: 39,
    year: 2023,
    rating: 8.5,
    director: '徐纪周',
    cast: ['张译', '张颂文', '李一桐', '张志坚'],
    status: '已完结',
    updateInfo: '全39集',
    featured: true,
    content: '《狂飙》是一部反映扫黑除恶斗争的电视剧，以安欣与高启强的正邪对决为主线，横跨二十年时间，展现了中国社会在扫黑除恶过程中的艰辛与成就。张译和张颂文的对手戏精彩绝伦，两人将角色的复杂心理变化演绎得入木三分。该剧凭借扎实的剧本、精湛的演技和深刻的主题，成为2023年现象级爆款剧集，引发了全社会的广泛讨论。',
  },
  {
    id: 'drama-3',
    title: '漫长的季节',
    category: '悬疑剧',
    categorySlug: 'xuanyi',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20mystery%20thriller%20drama%20poster%2C%20autumn%20leaves%20and%20industrial%20town%2C%20nostalgic%201990s%20China%20setting%2C%20mysterious%20and%20melancholic%20atmosphere%2C%20cinematic%20poster%2C%20warm%20golden%20and%20rust%20tones%2C%20clean%20background&width=600&height=800&seq=drama-3&orientation=portrait',
    description: '一座北方小城，一段尘封多年的往事。出租车司机王响在追寻真相的过程中，揭开了一桩跨越二十年的悬案谜团。',
    episodes: 12,
    year: 2023,
    rating: 9.4,
    director: '辛爽',
    cast: ['范伟', '秦昊', '陈明昊', '李庚希'],
    status: '已完结',
    updateInfo: '全12集',
    featured: true,
    content: '《漫长的季节》以三条时间线交织叙事，讲述了一桩发生在北方工业小城的连环案件。范伟饰演的王响从意气风发的火车司机变成了落魄的出租车司机，二十年的人生变迁与未解悬案紧密相连。该剧以其独特的叙事结构、深刻的社会洞察和出色的演员表演，被誉为近年来国产悬疑剧的巅峰之作。秋天的意象贯穿全剧，为故事增添了诗意的悲凉。',
  },
  {
    id: 'drama-4',
    title: '去有风的地方',
    category: '爱情剧',
    categorySlug: 'aiqing',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20romantic%20drama%20poster%2C%20couple%20in%20Yunnan%20countryside%2C%20sunny%20pastoral%20scenery%2C%20warm%20and%20healing%20atmosphere%2C%20gentle%20romance%2C%20cinematic%20poster%20style%2C%20soft%20natural%20lighting%2C%20clean%20background&width=600&height=800&seq=drama-4&orientation=portrait',
    description: '都市白领许红豆在好友离世后，独自前往云南大理云苗村"有风小院"休整。在那里，她邂逅了回乡创业的青年谢之遥，一段治愈心灵的爱情悄然展开。',
    episodes: 40,
    year: 2023,
    rating: 8.7,
    director: '丁梓光',
    cast: ['刘亦菲', '李现', '胡冰卿', '牛骏峰'],
    status: '已完结',
    updateInfo: '全40集',
    featured: false,
    content: '《去有风的地方》是一部治愈系田园爱情剧。刘亦菲饰演的许红豆在人生低谷来到云南大理，在这里她遇到了李现饰演的谢之遥，两人在相处中逐渐被彼此吸引。该剧以大理美丽的自然风光为背景，讲述了一个关于放下与重新出发的温暖故事。剧中对云南少数民族文化的展现和对现代人生活压力的反思，引起了广泛共鸣。',
  },
  {
    id: 'drama-5',
    title: '庆余年',
    category: '古装剧',
    categorySlug: 'guzhuang',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20fantasy%20drama%20poster%2C%20young%20man%20in%20ancient%20Chinese%20robe%20with%20sword%2C%20palace%20background%2C%20epic%20adventure%20theme%2C%20cinematic%20poster%20style%2C%20gold%20and%20crimson%20color%20palette%2C%20clean%20background&width=600&height=800&seq=drama-5&orientation=portrait',
    description: '一个患有重症肌无力的现代青年，重生到古代庆国成为范闲。凭借前世的记忆和智慧，他在庙堂与江湖之间纵横捭阖，揭开重重迷雾。',
    episodes: 46,
    year: 2019,
    rating: 8.0,
    director: '孙皓',
    cast: ['张若昀', '李沁', '陈道明', '吴刚'],
    status: '已完结',
    updateInfo: '全46集',
    featured: false,
    content: '《庆余年》改编自猫腻同名小说，讲述了一个现代人穿越到古代的故事。张若昀饰演的范闲凭借现代知识和智慧在古代世界闯出一片天地。该剧以幽默诙谐的叙事风格、错综复杂的权谋斗争和鲜明立体的人物塑造，赢得了观众的一致好评。陈道明、吴刚等老戏骨的加盟更为该剧增色不少。',
  },
  {
    id: 'drama-6',
    title: '三体',
    category: '科幻剧',
    categorySlug: 'kehuan',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20drama%20poster%2C%20mysterious%20three%20body%20problem%20concept%2C%20cosmic%20and%20futuristic%20theme%2C%20dark%20space%20background%20with%20stars%2C%20cinematic%20poster%20style%2C%20deep%20space%20blue%20and%20silver%20tones%2C%20clean%20design&width=600&height=800&seq=drama-6&orientation=portrait',
    description: '纳米科学家汪淼被警官史强带到联合作战中心，潜入神秘组织"科学边界"进行调查。在调查过程中，汪淼接触到了一个名为"三体"的虚拟现实游戏，一个关于外星文明的惊世秘密逐渐浮出水面。',
    episodes: 30,
    year: 2023,
    rating: 7.9,
    director: '杨磊',
    cast: ['张鲁一', '于和伟', '陈瑾', '王子文'],
    status: '已完结',
    updateInfo: '全30集',
    featured: false,
    content: '《三体》改编自刘慈欣同名科幻小说，是中国首部真正意义上的硬科幻电视剧。该剧忠实还原了原著的宏大世界观和深刻的思想内核，从"物理学不存在了"这一震撼开篇，层层揭开三体文明的神秘面纱。张鲁一饰演的汪淼和于和伟饰演的史强chemistry十足，两人的搭档为这部沉重的科幻题材注入了温度。',
  },
  {
    id: 'drama-7',
    title: '隐秘的角落',
    category: '悬疑剧',
    categorySlug: 'xuanyi',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20dark%20mystery%20drama%20poster%2C%20three%20children%20in%20summer%2C%20ominous%20coastal%20town%2C%20dark%20thriller%20atmosphere%2C%20cinematic%20poster%20style%2C%20moody%20lighting%2C%20warm%20but%20eerie%20tones%2C%20clean%20background&width=600&height=800&seq=drama-7&orientation=portrait',
    description: '三个孩子在景区游玩时无意间拍摄记录下了一场谋杀。他们的命运从此与凶手交织在一起，一场关于善恶、真相与成长的暗黑童话就此展开。',
    episodes: 12,
    year: 2020,
    rating: 8.8,
    director: '辛爽',
    cast: ['秦昊', '王景春', '荣梓杉', '史彭元'],
    status: '已完结',
    updateInfo: '全12集',
    featured: false,
    content: '《隐秘的角落》改编自紫金陈推理小说《坏小孩》，讲述了沿海小城三个孩子在景区游玩时无意拍摄记录了一次谋杀，从而卷入一场无法脱身的漩涡。秦昊饰演的张东升"我还有机会吗"成为经典台词。该剧以精妙的悬疑设计、深刻的人性探讨和电影级的制作水准，开创了国产悬疑短剧的新纪元。',
  },
  {
    id: 'drama-8',
    title: '武林外传',
    category: '喜剧',
    categorySlug: 'xiju',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20comedic%20martial%20arts%20drama%20poster%2C%20group%20of%20quirky%20characters%20in%20ancient%20Chinese%20inn%2C%20funny%20and%20warm%20atmosphere%2C%20vibrant%20colors%2C%20poster%20style%2C%20clean%20playful%20design&width=600&height=800&seq=drama-8&orientation=portrait',
    description: '以掌柜佟湘玉为首的同福客栈里，一群性格迥异的年轻人在江湖风雨中共同经营客栈，演绎了一段段令人捧腹又温情脉脉的故事。',
    episodes: 80,
    year: 2006,
    rating: 9.5,
    director: '尚敬',
    cast: ['闫妮', '姚晨', '沙溢', '喻恩泰'],
    status: '已完结',
    updateInfo: '全80集',
    featured: false,
    content: '《武林外传》是中国情景喜剧的巅峰之作。以同福客栈为舞台，通过夸张幽默的表演和机智诙谐的台词，讲述了一群"江湖人"的日常生活。剧中每个角色都有鲜明的个性和成长弧线：抠门但善良的佟湘玉、侠义又莽撞的郭芙蓉、胆小却重情的白展堂、迂腐而可爱的吕秀才。这部看似搞笑的喜剧，实则蕴含着对侠义精神、人情冷暖的深刻思考，陪伴了一代人的成长。',
  },
  {
    id: 'drama-9',
    title: '大明王朝1566',
    category: '历史剧',
    categorySlug: 'lishi',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20poster%2C%20Ming%20Dynasty%20emperor%20and%20ministers%20in%20court%2C%20solemn%20palace%20setting%2C%20epic%20political%20drama%2C%20cinematic%20poster%20style%2C%20golden%20and%20dark%20red%20tones%2C%20clean%20design&width=600&height=800&seq=drama-9&orientation=portrait',
    description: '明嘉靖年间，皇帝沉迷修道，朝政荒废。内阁首辅严嵩把持朝纲二十年，国库空虚，民不聊生。一场围绕国家命运的权谋斗争就此拉开帷幕。',
    episodes: 46,
    year: 2007,
    rating: 9.7,
    director: '张黎',
    cast: ['陈宝国', '黄志忠', '王庆祥', '倪大红'],
    status: '已完结',
    updateInfo: '全46集',
    featured: false,
    content: '《大明王朝1566》被誉为中国历史剧的"天花板"。该剧以嘉靖皇帝与海瑞的对抗为主线，展现了明朝中后期复杂的政治生态和尖锐的社会矛盾。陈宝国将嘉靖皇帝的复杂性格演绎得淋漓尽致，黄志忠饰演的海瑞正气凛然。剧中没有简单的好人坏人之分，每个人物都处于复杂的历史处境中，展现了历史的真实与残酷。',
  },
  {
    id: 'drama-10',
    title: '我的前半生',
    category: '现代剧',
    categorySlug: 'xiandai',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20modern%20urban%20drama%20poster%2C%20professional%20woman%20in%20office%20setting%2C%20modern%20Shanghai%20cityscape%2C%20elegant%20and%20sophisticated%20style%2C%20cinematic%20poster%2C%20warm%20neutral%20tones%2C%20clean%20design&width=600&height=800&seq=drama-10&orientation=portrait',
    description: '全职太太罗子君遭遇丈夫出轨离婚后，在闺蜜唐晶和其男友贺涵的帮助下，从一无所有的家庭主妇蜕变为独立自信的职场女性，同时也面临友情与爱情的两难抉择。',
    episodes: 42,
    year: 2017,
    rating: 7.3,
    director: '沈严',
    cast: ['马伊琍', '靳东', '袁泉', '雷佳音'],
    status: '已完结',
    updateInfo: '全42集',
    featured: false,
    content: '《我的前半生》改编自亦舒同名小说，讲述了全职太太罗子君在婚姻破裂后重新找回自我的故事。马伊琍将罗子君从娇生惯养到独立坚强的转变刻画得真实感人。袁泉饰演的唐晶和靳东饰演的贺涵也贡献了精彩的表演。该剧不仅是一部女性成长史，更是对当代都市人情感困境的深刻探讨。',
  },
  {
    id: 'drama-11',
    title: '甄嬛传',
    category: '古装剧',
    categorySlug: 'guzhuang',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20palace%20drama%20poster%2C%20beautiful%20woman%20in%20imperial%20%20Qing%20Dynasty%20costume%2C%20luxurious%20palace%20interior%2C%20dramatic%20and%20elegant%20style%2C%20cinematic%20poster%2C%20gold%20and%20crimson%20tones%2C%20clean%20design&width=600&height=800&seq=drama-11&orientation=portrait',
    description: '少女甄嬛入宫选秀，从一个不谙世事的单纯少女，在经历了无数次陷害与背叛后，成长为善于权谋的后宫太后。一场关于爱情、权力与生存的后宫传奇徐徐展开。',
    episodes: 76,
    year: 2011,
    rating: 9.3,
    director: '郑晓龙',
    cast: ['孙俪', '陈建斌', '蔡少芬', '蒋欣'],
    status: '已完结',
    updateInfo: '全76集',
    featured: false,
    content: '《甄嬛传》是国产宫斗剧的经典之作。孙俪饰演的甄嬛从单纯少女到后宫之主的蜕变令人震撼。剧中每一个人物都有鲜明的个性和完整的故事线，华妃的跋扈、皇后的阴险、安陵容的扭曲，都体现了人性的复杂。该剧不仅在服装、道具、场景上精益求精，更在剧本的文学性和思想性上达到了新的高度，成为一部可以反复品味的经典。',
  },
  {
    id: 'drama-12',
    title: '父母爱情',
    category: '爱情剧',
    categorySlug: 'aiqing',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20romantic%20family%20drama%20poster%2C%20middle-aged%20couple%20in%20vintage%20setting%2C%20warm%20family%20portrait%20style%2C%20nostalgic%201960s-1990s%20China%2C%20heartwarming%20atmosphere%2C%20soft%20golden%20lighting%2C%20clean%20design&width=600&height=800&seq=drama-12&orientation=portrait',
    description: '海军军官江德福与资本家小姐安杰，两个出身截然不同的人在特殊年代相遇相爱，携手走过半个世纪的风雨人生，谱写了一曲平凡而伟大的爱情赞歌。',
    episodes: 44,
    year: 2014,
    rating: 9.4,
    director: '孔笙',
    cast: ['郭涛', '梅婷', '刘琳', '任帅'],
    status: '已完结',
    updateInfo: '全44集',
    featured: false,
    content: '《父母爱情》讲述了海军军官江德福和资本家小姐安杰跨越半个世纪的爱情故事。两人从相识、相知到相守，经历了时代变迁和生活的酸甜苦辣。郭涛和梅婷的表演细腻真实，将平凡生活中的温情与感动演绎得淋漓尽致。这部剧没有波澜壮阔的剧情，却以最朴素的日常打动了无数观众，让人重新相信爱情的力量。',
  },
];

export const featuredDramas = dramas.filter((d) => d.featured);
export const latestDramas = dramas.slice(0, 6);